import React, { ReactNode } from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background: ${({ theme }) => theme.palette.textLight};
  border-radius: ${({ theme }) => theme.radius.large};
  padding: 3px;
  gap: 12px;
`;

const StyledItem = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: ${({ theme }) => theme.radius.large};
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  background: ${({ $active, theme }) => ($active ? theme.palette.white : 'transparent')};

  box-shadow: ${({ $active, theme }) => ($active ? `0 1px 3px ${theme.palette.grayLighter}` : 'none')};

  color: ${({ $active, theme }) => ($active ? theme.palette.text : theme.palette.grayLighter)};

  svg {
    font-size: 16px;
  }

  &:hover {
    color: ${({ theme }) => theme.palette.text};

    background: ${({ $active, theme }) => ($active ? theme.palette.white : theme.palette.grayLighter)};
  }
`;

export interface NgSegmentedToggleItem {
  icon?: ReactNode;
  label: string;
  type: 'slides' | 'suggestions' | 'outline';
}

interface NgSegmentedToggleProps {
  items: NgSegmentedToggleItem[];
  activeView: string;
  onChange: (type: Partial<'slides' | 'suggestions' | 'outline'>) => void;
}

export const NgSegmentedToggle: React.FC<NgSegmentedToggleProps> = ({ items, activeView, onChange }) => {
  return (
    <StyledContainer>
      {items.map((item, index) => (
        <StyledItem key={index} $active={item.type === activeView} onClick={() => onChange(item.type)}>
          {item.icon}
          {item.label}
        </StyledItem>
      ))}
    </StyledContainer>
  );
};
